import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=0fb2a384&scoped=true&"
import script from "./Step3.vue?vue&type=script&lang=js&"
export * from "./Step3.vue?vue&type=script&lang=js&"
import style0 from "./Step3.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Step3.vue?vue&type=style&index=1&id=0fb2a384&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2a384",
  null
  
)

export default component.exports